(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-wrapper.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-wrapper.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const _svs$components$lbUi$ = svs.components.lbUi.betslip,
  Betslip = _svs$components$lbUi$.Betslip,
  BetslipSticky = _svs$components$lbUi$.BetslipSticky;
const _svs$challenge = svs.challenge,
  BetslipPayOptionsContainer = _svs$challenge.BetslipPayOptionsContainer,
  actions = _svs$challenge.actions,
  BetslipStickyContentContainer = _svs$challenge.BetslipStickyContentContainer;
const format = svs.utils.format;
const config = svs.core.config;
const isSelfService = config.data.svsconfig.isSelfService;
const _svs$components$marke = svs.components.marketplace.accountSelector,
  AccountSelectorContainer = _svs$components$marke.AccountSelectorContainer,
  CommissionSelector = _svs$components$marke.CommissionSelector,
  useAccount = _svs$components$marke.useAccount,
  payGame = _svs$components$marke.payGame;
function makeUnpayableMessage(price) {
  if (price > svs.challenge.constants.MAX_COUPON_PRICE) {
    return "Systemet \xF6verskrider ".concat(format.Currency(svs.challenge.constants.MAX_COUPON_PRICE), " rader.");
  }
}
const BetslipWrapper = withRouter(_ref => {
  let match = _ref.match,
    getScrollContainer = _ref.getScrollContainer;
  const dispatch = useDispatch();
  function onInitiatePayment() {
    dispatch(actions.initiatePayment());
  }
  const drawNumber = Number(match.params.drawNumber);
  const _useAccount = useAccount(drawNumber, svs.utils.products.productIds.CHALLENGE),
    marketplaceAccount = _useAccount.marketplaceAccount,
    accountBalance = _useAccount.accountBalance,
    hasMarketplaceAccount = _useAccount.hasMarketplaceAccount;
  const _useSelector = useSelector(state => {
      const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
      return {
        isPayable: coupon.isPayable,
        betslipPrice: coupon.betSum
      };
    }),
    isPayable = _useSelector.isPayable,
    betslipPrice = _useSelector.betslipPrice;
  const onPayClickHandler = () => payGame({
    marketplaceAccount,
    drawNumber,
    productId: svs.utils.products.productIds.CHALLENGE
  }, onInitiatePayment);
  return React.createElement(Betslip, {
    accountBalance: accountBalance,
    errorMessage: makeUnpayableMessage(betslipPrice),
    getScrollContainer: getScrollContainer,
    isPayable: isPayable,
    isSelfService: isSelfService,
    onPay: onPayClickHandler,
    price: betslipPrice
  }, React.createElement("div", {
    className: "betslip-tag"
  }), React.createElement(BetslipSticky, null, hasMarketplaceAccount && marketplaceAccount && React.createElement("div", {
    className: "chlng-betslip-tag"
  }, marketplaceAccount.name || 'okänt'), React.createElement(BetslipStickyContentContainer, null)), React.createElement(BetslipPayOptionsContainer, null), hasMarketplaceAccount && React.createElement("div", {
    className: "account-selector-holder"
  }, svs.challenge.data.isRetailerAdmin && React.createElement(CommissionSelector, {
    className: "padding"
  }), React.createElement(AccountSelectorContainer, null)));
});
setGlobal('svs.challenge.BetslipWrapper', BetslipWrapper);

 })(window);